import React, { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { AppSettings } from '../../config/app-settings.js';

function PrivateRoute() {
  const context = useContext(AppSettings);
  const location = useLocation();

  // 💡 トークンをチェック
  const token = localStorage.getItem('access_token');

  // ❌ 【削除しました】context.isAuthLoading のスピナー判定
  // （App.jsx 側で完全にガードしているため、ここは100%通過しなくなりました）

  // 💡 トークンが無い、またはユーザー情報が空っぽならログイン画面へ強制送還
  if (!token || !context.userInfo) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // ログインが確認できていれば、本来の画面（Homeなど）を安全に表示
  return <Outlet />;
}

export default PrivateRoute;